<template>
  <div class="filterList">
      <v-autocomplete 
      v-model="selectedFilters" 
      :items="options" 
      :label="$t(label)" 
      :item-text="text" 
      :chips="chips" 
      :clearable="clearable" 
      :dense="dense" 
      :deletable-chips="deletableChips"
      :filled="filled" 
      :multiple="multiple" 
      :rounded="rounded" 
      :small-chips="smallChips"
      return-object>
      <template v-slot:item="{ item }" v-if="icon && !translate"> <!-- For now only client type can have an icon. Other filters may break if they have one -->
        <v-icon class="mr-1"> {{ item.icon }} </v-icon>
        {{ item.text.toString() }}
      </template>
      <template v-slot:item="{ item }" v-else-if="translate && !icon"> <!-- For now only client type can have an icon. Other filters may break if they have one -->
        {{ $t(item) }} 
      </template>
      <template v-slot:item="{ item }" v-else-if="translate && icon"> <!-- For now only client type can have an icon. Other filters may break if they have one -->
        <v-icon class="mr-1"> {{ item.icon }} </v-icon>
        {{ $t(item.text.toString()) }} 
      </template>
      <template v-slot:no-data>
        <div class="px-4">{{ noDataMessage ? $t(noDataMessage) : $t('comboNoData') }}</div>
      </template>
      <template v-if="groupSelected" v-slot:selection="data">
        <div v-if="selectedFilters.length < 4">
          {{ data.index > 0 ? ',' : '' }}  
          {{ `${ translate ? $t(data.item[text].trim()): data.item[text].trim()}` }}
          <!-- <span v-if="selectedFilters.length > 1">&nbsp;</span> -->
        </div>
        <v-chip small v-else-if="data.index === 0">
          {{ `${selectedFilters.length} ${$t('itemsSelected')}` }}
        </v-chip>
      </template>
      <template v-else-if="translate && !icon" v-slot:selection="data">
        <v-chip small>
          {{ $t(data.item) }}
        </v-chip>
      </template>
      <template v-else-if="translate && icon" v-slot:selection="data">
        <v-chip small>
          <v-icon class="mr-1"> {{ data.item.icon }} </v-icon>
          {{ $t(data.item.text.toString()) }} 
        </v-chip>
      </template>
      <template v-if="selectAll && multiple && (options?.length > 0)" v-slot:prepend-item>
          <v-list-item @click="doSelectAll">
            <v-list-item-action>
                  <v-checkbox
                  ripple="false"
                  disabled
                  class="grayBold--text"
                  v-model="allOptionsSelectedFlag"
                ></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{$t('selectAll')}}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider> 
      </template>
    </v-autocomplete>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class FilterList extends Vue {
  @Prop() options!: any[];
  @Prop() defaultValues!: any[];
  @Prop() label!: string;
  @Prop() text!: string;
  @Prop() multiple!: boolean;
  @Prop({ default: false }) icon!: boolean;
  @Prop({ default: true }) clearable!: boolean;
  @Prop({ default: true }) deletableChips!: boolean;
  @Prop({ default: false }) dense!: boolean;
  @Prop({ default: true }) chips!: boolean;
  @Prop({ default: true }) smallChips!: boolean;
  @Prop({ default: true }) rounded!: boolean;
  @Prop({ default: true }) filled!: boolean;
  @Prop({ default: false }) preSelectFirstItem!: boolean;
  @Prop({ default: false }) selectAll!: boolean;
  @Prop({ default: false }) groupSelected!: boolean;
  @Prop({ default: false }) translate!: boolean;
  @Prop({ default: null }) noDataMessage!: string;
  
  
  selectedFilters = this.defaultValues ?? [];
  allOptionsSelectedFlag = false;

  mounted() {
    if(this.preSelectFirstItem) {
      this.selectedFilters = this.options[0];
    }
  }

  doSelectAll() {
    this.allOptionsSelectedFlag = !this.allOptionsSelectedFlag;
    if (this.allOptionsSelectedFlag) {
      this.selectedFilters = this.options;
    }
    else {
      this.selectedFilters = [];
    }

  }

  @Watch("selectedFilters")
  selectFilter() {
    this.$emit('update-filter', this.selectedFilters);
  }
}
</script>

<style>
.filterList {
  width: 450px;
  margin: 0;
  padding: 0;
  z-index: 0;
}
</style>